module.exports = __webpack_public_path__ + "static/media/application_4.36c642f0.png";